<template>
	<div class="mb-5">
		<div class="row justify-content-end mb-2">
			<b-col md="4">
				<b-form-datepicker placeholder="Choose a date" local="en" v-model="from_date" />
			</b-col>
			<div md="1" class="d-flex align-items-center ml-1">to</div>
			<b-col md="4">
				<b-form-datepicker placeholder="Choose a date" local="en" v-model="to_date" @input="getData()" />
			</b-col>
		</div>
		<!-- <div style="display: flex; justify-content: end">
			<label class="switch">
				<input type="checkbox" value="Farm" unchecked-value="User" @click="$bvModal.show('user_modal')" />
				Farm
				<span class="slider round"></span>
			</label>
		</div> -->
		<div v-if="infoData">
			<div v-for="data in infoData" :key="data.id">
				<div class="row match-height mb-1">
					<div class="col-md-2 p-0">
						<div class="card card-congratulations">
							<div class="py-2 px-1 text-center">
								<b-img
									:src="require('@/assets/images/svg/hatchery/card-top.svg')"
									class="svg-img mb-1"
									style="height: 24px; width: 24px"
								/>
								<div class="text-center">
									<h6 class="font-small-2 text-white">Poultrac</h6>
									<h4 class="mb-1 text-white w-100">
										<!-- {{ info.hatchery_name || "NA" }} -->
									</h4>
								</div>

								<div class="d-flex flex-column justify-content-between" style="align-items: center">
									<div class="d-flex justify-content-between mt-1">
										<p class="card-text">{{ data.shed_name }}</p>
										<!-- <p class="card-text">{{ index + 1 }}</p> -->
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-10 card card-statistics">
						<div class="card-header"></div>
						<div class="card-body statistics-body">
							<div class="row">
								<div class="col-12 d-flex" style="justify-content: space-between">
									<div class="col-sm-6 col-md-4 col-xl-3 pl-0 mb-xl-0">
										<div class="media">
											<div class="media-aside mr-2 align-self-start">
												<span
													class="b-avatar badge-light-primary rounded-circle"
													style="width: 48px; height: 48px"
													><span class="b-avatar-custom"
														><b-img
															:src="
																require('@/assets/images/dashboard/number_of_birds.svg')
															"
															style="height: 48px; width: 48px"
														/> </span
													><!----></span
												>
											</div>
											<div class="media-body my-auto">
												<h4 class="font-weight-bolder mb-0">
													<!-- {{ info.total_chick_sale_format || "NA" }} -->
													{{ data.totalBirds }}
												</h4>
												<p class="card-text font-small-3 mb-0">No of Birds</p>
											</div>
										</div>
									</div>
									<div class="col-sm-6 col-md-4 col-xl-3 pl-0 mb-xl-0">
										<div class="media">
											<div class="media-aside mr-2 align-self-start">
												<span
													class="b-avatar badge-light-info rounded-circle"
													style="width: 48px; height: 48px"
													><span class="b-avatar-custom"
														><b-img
															:src="require('@/assets/images/dashboard/mortality.svg')"
															style="height: 48px; width: 48px"
														/> </span
													><!----></span
												>
											</div>
											<div class="media-body my-auto">
												<h4 class="font-weight-bolder mb-0">
													<!-- {{ info.total_egg_purchase_format || "NA" }} -->
													{{ data.mortalityRate }} %
												</h4>
												<p class="card-text font-small-3 mb-0">Mortality Rate</p>
											</div>
										</div>
									</div>
									<div class="col-sm-6 col-md-4 col-xl-3 pl-0 mb-sm-0">
										<div class="media">
											<div class="media-aside mr-2 align-self-start">
												<span
													class="b-avatar badge-light-primary rounded-circle"
													style="width: 48px; height: 48px"
													><span class="b-avatar-custom"
														><b-img
															:src="require('@/assets/images/dashboard/ready_sell.svg')"
															style="height: 48px; width: 48px"
														/> </span
													><!----></span
												>
											</div>
											<div class="media-body my-auto">
												<h4 class="font-weight-bolder mb-0">
													<!-- {{ info.total_egg_purchase_format || "NA" }} -->
													{{ data.readyToSale }}
												</h4>
												<p class="card-text font-small-3 mb-0">Ready To Sell(Birds)</p>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 d-flex mt-4" style="justify-content: space-between">
									<div class="col-sm-6 col-md-4 col-xl-3 pl-0 mb-xl-0">
										<div class="media">
											<div class="media-aside mr-2 align-self-start">
												<span
													class="b-avatar badge-light-primary rounded-circle"
													style="width: 48px; height: 48px"
													><span class="b-avatar-custom"
														><b-img
															:src="require('@/assets/images/dashboard/average_body.svg')"
															style="height: 48px; width: 48px"
														/> </span
													><!----></span
												>
											</div>
											<div class="media-body my-auto">
												<h4 class="font-weight-bolder mb-0">
													<!-- {{ info.total_chick_sale_format || "NA" }} -->
													{{ data.avgBodyWeight }}
												</h4>
												<p class="card-text font-small-3 mb-0">Avg Body Weight</p>
											</div>
										</div>
									</div>
									<div class="col-sm-6 col-md-4 col-xl-3 pl-0 mb-xl-0">
										<div class="media">
											<div class="media-aside mr-2 align-self-start">
												<span
													class="b-avatar badge-light-info rounded-circle"
													style="width: 48px; height: 48px"
													><span class="b-avatar-custom"
														><b-img
															:src="
																require('@/assets/images/dashboard/chick_placement.svg')
															"
															style="height: 48px; width: 48px"
														/> </span
													><!----></span
												>
											</div>
											<div class="media-body my-auto">
												<h4 class="font-weight-bolder mb-0">
													<!-- {{ info.total_egg_purchase_format || "NA" }} -->
													{{ data.chickPlacement }}
												</h4>
												<p class="card-text font-small-3 mb-0">Chick Placement</p>
											</div>
										</div>
									</div>
									<div class="col-sm-6 col-md-4 col-xl-3 pl-0 mb-sm-0">
										<div class="media">
											<div class="media-aside mr-2 align-self-start">
												<span
													class="b-avatar badge-light-primary rounded-circle"
													style="width: 48px; height: 48px"
													><span class="b-avatar-custom"
														><b-img
															:src="require('@/assets/images/dashboard/fcr.svg')"
															style="height: 48px; width: 48px"
														/> </span
													><!----></span
												>
											</div>
											<div class="media-body my-auto">
												<h4 class="font-weight-bolder mb-0">
													<!-- {{ info.total_egg_purchase_format || "NA" }} -->
													{{ data.FCR }}
												</h4>
												<p class="card-text font-small-3 mb-0">FCR</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<b-card>
				<div class="d-flex top-header align-items-center">
					<feather-icon icon="ArrowLeftIcon" size="24" class="mr-2" @click="goBack" style="cursor: pointer" />
					<div>
						<h5>No Data Found</h5>
					</div>
				</div>
				<div class="d-flex flex-column justify-content-center align-items-center py-5">
					<b-img :src="require('@/assets/images/svg/machine/no-setter.svg')" class="mr-2" />
					<h4 class="mt-2 Secondary">No Shed data available</h4>
				</div>
			</b-card>
		</div>
	</div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
	BCard,
	BCardHeader,
	BCardTitle,
	BCardText,
	BCardBody,
	BRow,
	BCol,
	BMedia,
	BMediaAside,
	BAvatar,
	BMediaBody,
	BCarousel,
	BCarouselSlide,
	BButton,
	BImg,
	BFormDatepicker,
	BFormGroup,
} from "bootstrap-vue";

import vSelect from "vue-select";
import axiosIns from "@/libs/axios";
import moment from "moment";
export default {
	components: {
		BRow,
		BCol,
		BCard,
		BCardHeader,
		BCardTitle,
		BCardText,
		BCardBody,
		BMedia,
		BAvatar,
		BMediaAside,
		BMediaBody,
		BButton,
		BFormDatepicker,
		BCarousel,
		BCarouselSlide,
		BImg,
		BFormGroup,
		vSelect,
	},
	data() {
		return {
			infoData: [],
			info: {},
			shedCount: null,
			search_filter: {
				input_field: "",
				to_date: "",
				from_date: "",
			},
			from_date: null,
			to_date: null,
			shedId: null,
		};
	},

	created() {
		this.shedId = this.$route.params.shedId;
		this.fromDate = moment().clone().startOf("month").format("YYYY-MM-DD");
		this.toDate = moment().clone().endOf("month").format("YYYY-MM-DD");
		this.getData(this.$route.params.shedId);
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		getData(shedId) {
			if (!shedId) {
				shedId = this.$route.params.shedId;
			}
			let url = "";
			if (this.from_date != null && this.to_date != null) {
				url = `web/shed/${shedId}/broiler-details?from_date=${this.from_date}&to_date=${this.to_date}`;
			} else {
				url = `web/shed/${shedId}/broiler-details?from_date=${this.fromDate}&to_date=${this.toDate}`;
			}
			axiosIns
				.get(url)
				.then((response) => {
					this.infoData = response.data.shed_info;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},
	},
};
</script>
<style lang="scss">
.shed {
	align-items: center !important;
}
.carousel-inner {
	height: 200px !important;
}
.top-header {
	border-bottom: 1px solid #296db4;
	padding: 1rem 0rem;
}
.switch {
	position: relative;
	display: inline-block;
	width: 50px;
	height: 25px;
}

.switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #ccc;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

.slider:before {
	position: absolute;
	content: "";
	height: 18px;
	width: 20px;
	left: 2px;
	bottom: 4px;
	background-color: white;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

input:checked + .slider {
	background-color: #2196f3;
}

input:focus + .slider {
	box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
	-webkit-transform: translateX(26px);
	-ms-transform: translateX(26px);
	transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
	border-radius: 34px;
}

.slider.round:before {
	border-radius: 50%;
}
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/pages/hatchery.scss";
@import "@core/scss/vue/pages/_common.scss";
</style>
